module.exports = __webpack_public_path__ + "img/fifth3.4656137b.png";